import React, { useState } from 'react';
import { CountdownTimer } from './CountdownTimer';
import { CheckIcon, StarIcon } from 'lucide-react';
const CHECKOUT_BASIC = 'https://checkout.recursodigital.shop/cart/41301282291770:1';
const CHECKOUT_INTERMEDIATE = 'https://checkout.recursodigital.shop/cart/41301282291770:1';
const CHECKOUT_COMPLETE = 'https://checkout.recursodigital.shop/cart/41301282291770:1';
type PackType = 'basic' | 'intermediate' | 'complete';
export function PricingSection() {
  const [selectedPack, setSelectedPack] = useState<PackType>('complete');
  const getCheckoutUrl = () => {
    switch (selectedPack) {
      case 'basic':
        return CHECKOUT_BASIC;
      case 'intermediate':
        return CHECKOUT_INTERMEDIATE;
      case 'complete':
        return CHECKOUT_COMPLETE;
    }
  };
  return <section id="pricing" className="w-full bg-[#0a0a0a] py-12 md:py-16 px-4" data-id="element-274">
      <div className="max-w-3xl mx-auto" data-id="element-275">
        {/* Countdown */}
        <div className="text-center mb-10" data-id="element-276">
          <p className="text-yellow-400 font-bold text-lg md:text-xl mb-4 font-heading" data-id="element-277">
            ⏰ EL PRECIO DE LANZAMIENTO TERMINA EN:
          </p>
          <CountdownTimer data-id="element-278" />
          <p className="text-gray-400 text-sm mt-4 font-body" data-id="element-279">
            Después sube el precio y no vuelve a bajar
          </p>
        </div>

        <div className="text-center mb-8" data-id="element-280">
          <h2 className="text-3xl md:text-4xl font-black font-heading text-white mb-2" data-id="element-281">
            Elige tu <span className="text-yellow-400" data-id="element-282">MegaPack:</span>
          </h2>
          <p className="text-gray-400 font-body" data-id="element-283">
            Todas las opciones incluyen los 3 bonos estratégicos
          </p>
        </div>

        <div className="space-y-4 mb-8" data-id="element-284">
          {/* Pack Básico */}
          <div onClick={() => setSelectedPack('basic')} className={`cursor-pointer rounded-2xl p-5 md:p-6 border-2 transition-all duration-300 flex items-center gap-4 ${selectedPack === 'basic' ? 'bg-gray-800 border-yellow-400 shadow-[0_0_20px_rgba(250,204,21,0.15)]' : 'bg-gray-900 border-gray-800 hover:border-gray-700'}`} data-id="element-285">
            {/* Radio Button */}
            <div className="flex-shrink-0" data-id="element-286">
              <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${selectedPack === 'basic' ? 'border-yellow-400' : 'border-gray-500'}`} data-id="element-287">
                {selectedPack === 'basic' && <div className="w-3 h-3 rounded-full bg-yellow-400" data-id="element-288" />}
              </div>
            </div>

            <div className="flex-1 flex flex-col md:flex-row md:items-center justify-between gap-4" data-id="element-289">
              <div data-id="element-290">
                <div className="flex items-center gap-2 mb-1" data-id="element-291">
                  <span className="text-xl" data-id="element-292">📘</span>
                  <h3 className="text-lg md:text-xl font-black font-heading text-white" data-id="element-293">
                    PACK BÁSICO
                  </h3>
                </div>
                <p className="text-sm md:text-base text-gray-400 font-body" data-id="element-294">
                  5 tomos + 3 bonos
                </p>
              </div>
              <div className="text-left md:text-right" data-id="element-295">
                <p className="text-sm text-gray-500 line-through font-body" data-id="element-296">
                  USD 19.90
                </p>
                <p className="text-2xl md:text-3xl font-black font-heading text-white" data-id="element-297">
                  USD 11.90
                </p>
              </div>
            </div>
          </div>

          {/* Pack Completo */}
          <div onClick={() => setSelectedPack('complete')} className={`cursor-pointer rounded-2xl p-5 md:p-6 border-2 transition-all duration-300 flex items-start md:items-center gap-4 ${selectedPack === 'complete' ? 'bg-gray-800 border-yellow-400 shadow-[0_0_20px_rgba(250,204,21,0.25)] scale-[1.02] md:scale-105 z-10 relative' : 'bg-gray-900 border-gray-800 hover:border-gray-700'}`} data-id="element-298">
            {/* Radio Button */}
            <div className="flex-shrink-0 mt-2 md:mt-0" data-id="element-299">
              <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${selectedPack === 'complete' ? 'border-yellow-400' : 'border-gray-500'}`} data-id="element-300">
                {selectedPack === 'complete' && <div className="w-3 h-3 rounded-full bg-yellow-400" data-id="element-301" />}
              </div>
            </div>

            <div className="flex-1 flex flex-col md:flex-row md:items-center justify-between gap-4" data-id="element-302">
              <div data-id="element-303">
                <div className="flex items-center gap-2 mb-2" data-id="element-304">
                  <span className="text-xl" data-id="element-305">🏆</span>
                  <h3 className="text-lg md:text-xl font-black font-heading text-white" data-id="element-306">
                    PACK COMPLETO
                  </h3>
                </div>
                <div className="flex flex-wrap gap-2 mb-3" data-id="element-307">
                  <span className="bg-yellow-400 text-black text-xs font-bold px-2 py-1 rounded flex items-center gap-1 font-heading" data-id="element-308">
                    <StarIcon className="w-3 h-3 fill-black" data-id="element-309" /> MÁS ELEGIDO
                  </span>
                  <span className="border border-yellow-600 text-yellow-500 text-xs font-bold px-2 py-1 rounded font-heading" data-id="element-310">
                    AHORRAS USD 7.90
                  </span>
                </div>
                <p className="text-sm md:text-base text-gray-400 font-body mb-2" data-id="element-311">
                  Todo lo anterior +
                </p>
                <ul className="space-y-1" data-id="element-312">
                  <li className="text-sm md:text-base text-gray-300 font-body flex items-start gap-2" data-id="element-313">
                    <CheckIcon className="w-4 h-4 text-green-500 mt-0.5 flex-shrink-0" data-id="element-314" />
                    Crianza digital avanzada
                  </li>
                  <li className="text-sm md:text-base text-gray-300 font-body flex items-start gap-2" data-id="element-315">
                    <CheckIcon className="w-4 h-4 text-green-500 mt-0.5 flex-shrink-0" data-id="element-316" />
                    Sistema de personalización y entorno familiar
                  </li>
                </ul>
              </div>
              <div className="text-left md:text-right mt-2 md:mt-0" data-id="element-317">
                <p className="text-sm text-gray-500 line-through font-body" data-id="element-318">
                  USD 39.90
                </p>
                <p className="text-3xl md:text-4xl font-black font-heading text-yellow-400" data-id="element-319">
                  USD 19.90
                </p>
              </div>
            </div>
          </div>

          {/* Pack Intermedio */}
          <div onClick={() => setSelectedPack('intermediate')} className={`cursor-pointer rounded-2xl p-5 md:p-6 border-2 transition-all duration-300 flex items-center gap-4 ${selectedPack === 'intermediate' ? 'bg-gray-800 border-yellow-400 shadow-[0_0_20px_rgba(250,204,21,0.15)]' : 'bg-gray-900 border-gray-800 hover:border-gray-700'}`} data-id="element-320">
            {/* Radio Button */}
            <div className="flex-shrink-0" data-id="element-321">
              <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${selectedPack === 'intermediate' ? 'border-yellow-400' : 'border-gray-500'}`} data-id="element-322">
                {selectedPack === 'intermediate' && <div className="w-3 h-3 rounded-full bg-yellow-400" data-id="element-323" />}
              </div>
            </div>

            <div className="flex-1 flex flex-col md:flex-row md:items-center justify-between gap-4" data-id="element-324">
              <div data-id="element-325">
                <div className="flex items-center gap-2 mb-1" data-id="element-326">
                  <span className="text-xl" data-id="element-327">📗</span>
                  <h3 className="text-lg md:text-xl font-black font-heading text-white" data-id="element-328">
                    PACK INTERMEDIO
                  </h3>
                </div>
                <p className="text-sm md:text-base text-gray-400 font-body" data-id="element-329">
                  Todo lo anterior + Manual completo de comunicación parental
                </p>
              </div>
              <div className="text-left md:text-right" data-id="element-330">
                <p className="text-sm text-gray-500 line-through font-body" data-id="element-331">
                  USD 25.90
                </p>
                <p className="text-2xl md:text-3xl font-black font-heading text-white" data-id="element-332">
                  USD 13.90
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* CTA Button */}
        <div className="mt-8" data-id="element-333">
          <a href={getCheckoutUrl()} className="block w-full bg-yellow-400 hover:bg-yellow-500 text-gray-900 font-black text-xl md:text-2xl py-5 rounded-xl text-center transition-colors duration-200 cursor-pointer font-heading shadow-lg" data-id="element-334">
            👉 QUIERO MI MEGAPACK AHORA
          </a>

          {/* Trust badges */}
          <div className="flex flex-wrap justify-center gap-6 mt-6 text-sm md:text-base text-gray-400 font-body" data-id="element-335">
            <span className="flex items-center gap-1" data-id="element-336">🔒 Pago seguro</span>
            <span className="flex items-center gap-1" data-id="element-337">⚡ Acceso inmediato</span>
            <span className="flex items-center gap-1" data-id="element-338">🛡️ Garantía 7 días</span>
          </div>
        </div>
      </div>
    </section>;
}